import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      cart: 'centra-cart/cart'
    }),
    cartEmpty () {
      return this.cart === undefined || (this.cart.items && this.cart.items.length === 0)
    }
  }
}
